import { Button } from 'react-bootstrap';
import UserAdminItems from './UsersRowItems/UserAdminItems';
import UserNameItem from './UsersRowItems/UserNameItem';
import UserRoleItem from './UsersRowItems/UserRoleItem';
import UserStatItems from './UsersRowItems/UserStatItem';
import UserTeamItem from './UsersRowItems/UserTeamItem';
import type { UserRowProps } from './types';
import SolarIcon from 'components/icons/SolarIcon';

const UsersTableRow = ({
    user,
    setShowSpinner,
    fetchUsers,
    setShowUserCard,
    showRole,
    showTeam,
    showAdmin,
}: UserRowProps) => {
    return (
        <tr>
            <td className="username">
                <UserNameItem user={user} setShowUserCard={setShowUserCard} />
            </td>
            {showRole ? (
                <td className="role">
                    <UserRoleItem user={user} />
                </td>
            ) : null}
            {showTeam ? (
                <td className="team">
                    <UserTeamItem user={user} />
                </td>
            ) : null}
            {showAdmin ? (
                <td className="admin">
                    <UserAdminItems user={user} />
                </td>
            ) : null}
            <td className="status">
                <UserStatItems fetchUsers={fetchUsers} setShowSpinner={setShowSpinner} user={user} />
            </td>
            <td className="action">
                <Button
                    className="p-1 py-0"
                    size="sm"
                    variant="light-secondary"
                    onClick={(e) => {
                        e.currentTarget.blur();
                        setShowUserCard(user.ID);
                    }}>
                    <SolarIcon name="three-dots" />
                </Button>
            </td>
        </tr>
    );
};

export default UsersTableRow;
